import type { FetchZoneListParams, Zone } from 'Services/ControlDataManagement/Features/Zone/types'
import type { ListResponse } from 'Services/ControlDataManagement/types'
import { createBaseApi } from 'Util/ApiClient'

enum TagTypes {
  ZONE = 'Zone'
}

export const zoneApi = createBaseApi({
  reducerPath: 'zoneApi',
  keepUnusedDataFor: 5,
  tagTypes: [TagTypes.ZONE]
}).injectEndpoints({
  endpoints: builder => ({
    getZones: builder.query<ListResponse<Zone>, FetchZoneListParams | undefined>({
      query: params => ({
        url: '/api/v1/zone/',
        params
      }),
      providesTags: result =>
        result
          ? [
              ...result.resources.map(({ id }) => ({ type: TagTypes.ZONE, id }) as const),
              { type: TagTypes.ZONE, id: 'LIST' }
            ]
          : [{ type: TagTypes.ZONE, id: 'LIST' }]
    }),
    getSingleZone: builder.query<Zone, string>({
      query: id => `/api/v1/zone/${id}/`,
      providesTags: (_result, _error, id) => [{ type: TagTypes.ZONE, id }]
    }),
    createSingleZone: builder.mutation<Zone, Partial<Zone>>({
      query: data => ({
        url: `/api/v1/zone/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: [{ type: TagTypes.ZONE, id: 'LIST' }]
    }),
    updateSingleZone: builder.mutation<Zone, { id: string } & Partial<Zone>>({
      query: data => ({
        url: `/api/v1/zone/${data.id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: TagTypes.ZONE, id }]
    }),
    deleteSingleZone: builder.mutation<Record<string, never>, string>({
      query: id => ({
        url: `/api/v1/zone/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: TagTypes.ZONE, id: 'LIST' }]
    })
  })
})

export const {
  useGetZonesQuery,
  useGetSingleZoneQuery,
  useCreateSingleZoneMutation,
  useUpdateSingleZoneMutation,
  useDeleteSingleZoneMutation
} = zoneApi
